//
// Single - Text (i.e. button)
//
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { CTA, Flex } from 'ui/chandra'
import SelectBoxBase from './_bases/SelectBox'
import Selected from './_modifiers/Selected'

const StyledParagraph = styled('p')`
  font-size: 16px;
  font-family: ${(props) => props.theme.fonts.Proxima};
  letter-spacing: 0.352px;
  line-height: 24px;
  text-transform: uppercase;
  text-weight: heavy;

  @media all and (max-width: 1024px) {
    font-size: 14px;
  }
`

const CTAContainer = styled(CTA)`
  font-family: ${(props) => props.theme.fonts.Proxima};
  font-size: 18px;
  letter-spacing: 1px;
  text-transform: inherit;
  text-align: left;
  margin-left: 11px;
  font-weight: 600;

  @media all and (max-width: 1024px) {
    margin-top: 6px;
  }
`

const Select00 = ({
  component,
  handleSelect,
  isSelected,
  step,
  updatedSelected
}) => {
  const Container = styled(Flex)`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    margin-button: 30px;

    @media all and (max-width: 1024px) {
      justify-content: center;
      margin-button: null;
    }

    @media all and (max-width: 640px) {
      justify-content: center;
      margin-button: 30px;
    }
  `

  const RowContainer = styled(Container)`
    flex-direction: row;
    gap: 12px;
    max-width: 100%;
    flex-wrap: ${(props) => (props.shouldWrap ? 'wrap' : 'nowrap')};
    @media all and (max-width: 1024px) {
      flex-wrap: wrap;
    }
  `

  const SelectBox = styled(SelectBoxBase)`
    display: flex;
    padding: 15px;
    font-size: 15px;
    flex-basis: 50%;
    box-sizing: border-box;
    flex: 1;
    width: 100%;
    min-width: 100%;

    &:not(:last-child) {
      margin-bottom: 16px;
    }
  `
  const ExtraSmallSelectBox = styled(SelectBoxBase)`
    max-width: 19%;
    min-width: 18%;
    box-sizing: border-box;
    padding: 10px;
    height: 56px;

    @media all and (max-width: 1024px) {
      min-width: 45%;
      max-width: 45%;
      margin-right: auto;
    }
  `

  const SmallerSelectBox = styled(SelectBox)`
    width: 187px;
    min-width: 187px;

    @media all and (max-width: 1024px) {
      width: 96px;
      min-width: 96px;
      height: 56px;
    }
  `

  const SelectedContainer = (() => {
    switch (step) {
      case (2, 6):
        return RowContainer
      case 4:
        return Container
      default:
        return Container
    }
  })()

  const SelectedBoxContainer = (() => {
    switch (step) {
      case 2:
        return SmallerSelectBox
      case 4:
        return SelectBox
      case 6:
        return ExtraSmallSelectBox
      default:
        return SelectBox
    }
  })()
  const shouldWrap = component.options.length > 5

  return (
    <div>
      {step === 2 && <CTAContainer>I identify as</CTAContainer>}
      <SelectedContainer shouldWrap={shouldWrap}>
        {component.options &&
          component.options.map((option) => {
            const selected = isSelected(option)
            const expSelector = option.prompt.replace(/\s+/g, '-').toLowerCase()
            return (
              <SelectedBoxContainer
                id={`select-00-${expSelector}-${step}`}
                key={option.slug}
                onClick={() => handleSelect(option)}
                selected={selected}
                color={updatedSelected.length > 0 ? '#CCCCCC' : '#000000'}
              >
                {option.prompt && (
                  <StyledParagraph
                    dangerouslySetInnerHTML={{ __html: option.prompt }}
                  />
                )}
                <Selected selected={selected} />
              </SelectedBoxContainer>
            )
          })}
      </SelectedContainer>
    </div>
  )
}

Select00.propTypes = {
  component: PropTypes.object.isRequired,
  handleSelect: PropTypes.func.isRequired,
  isSelected: PropTypes.func.isRequired,
  updatedSelected: PropTypes.any
}

export default Select00
